module.exports = __webpack_public_path__ + "static/media/HomeRoll_Roof_SlateRoof.7cb09196.jpg";